import React, { ReactNode } from 'react'

import { LockIcon, MoonIcon, PauseIcon } from '@Static/icons/SpotOrderIcons'
import cn from 'clsx'
import { createPortal } from 'react-dom'
import { Tooltip as ReactTooltip } from 'react-tooltip'

import type { IConfigMarket } from '@App/redux/interfaces'
import { MarketMode } from '@App/redux/interfaces'

import classes from './styles.module.scss'

const getTooltipText = (market: IConfigMarket): ReactNode | null => {
  if (market.mode === MarketMode.CLOSED_ONLY) {
    return (
      <span>
        Market is closed.
        <br />
        You cannot place or edit orders.
      </span>
    )
  }
  if (!market.enabled) {
    return (
      <span>
        Market is currently untradeable.
        <br />
        You can still edit positions and place new orders.
      </span>
    )
  }
  if (!market.is_open) {
    return (
      <span>
        Market is offline.
        <br />
        Orders will be processed when the market reopens.
      </span>
    )
  }
  return null
}

export const MarketStatusIcon = ({ market, className }: { market: IConfigMarket; className?: string }) => {
  const tooltip = getTooltipText(market)

  if (!tooltip) return null

  let type: 'lock' | 'pause' | 'moon'
  if (market.mode === MarketMode.CLOSED_ONLY) type = 'lock'
  else if (!market.enabled) type = 'pause'
  else type = 'moon'

  const Icon = type === 'lock' ? LockIcon : type === 'pause' ? PauseIcon : MoonIcon

  return (
    <div
      data-tooltip-id={`tooltip ${market.id}`}
      className={cn(
        classes.statusIconContainer,
        {
          [classes.closed]: type === 'lock',
          [classes.disabled]: type === 'pause',
          [classes.offline]: type === 'moon',
        },
        className,
      )}
    >
      <Icon width={12} height={12} />
      {tooltip &&
        createPortal(
          <ReactTooltip
            className={classes.tooltip}
            id={`tooltip ${market.id}`}
            place="top-start"
            opacity={1}
            children={tooltip}
          />,
          document.body,
        )}
    </div>
  )
}
